import { render, staticRenderFns } from "./SharePlanAcademicChairModal.vue?vue&type=template&id=97f1137a&scoped=true&"
import script from "./SharePlanAcademicChairModal.vue?vue&type=script&lang=js&"
export * from "./SharePlanAcademicChairModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1137a",
  null
  
)

export default component.exports